<ng-container *transloco="let convert;">
<app-modal modalId="action-submitted-content-modal">
  <header class="modal__header mb-3 d-flex align-items-center justify-content-center">
    <app-check-icon class="check-mark" fill="#00A664"></app-check-icon>
    <h1
      class="modal__title title ms-2 mb-0"
      id="action-success-modal-title"
      tabindex="-1"
    >
      {{ heading }}
    </h1>
  </header>
  <div class="modal__content form-group">
    <p
      class="modal__content--info text-center"
    >
      {{content}}
    </p>
  </div>
  <div class="modal__action">
    <button
      class="btn btn-primary mt-4"
      (click)="close()"
    >
      {{ convert('common.btnClose') }}
    </button>
  </div>
  <div class="modal-close-container">
    <button
      class="modal__close"
      [attr.aria-label]="convert('common.modalClose')"
      (click)="close()"
      data-track-elem="icon"
      data-track-name="Close"
      data-track-trigger="close"
      id="do_close_x_button"
    >
      <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
    </button>
  </div>
</app-modal>
</ng-container>
